module.exports = __webpack_public_path__ + "img/20170314泉润gaga.40e28be5.jpg";